// Appels HTTP typés vers /api/auth/*.

import { api } from "./client";
import type { AuthResponse, MeResponse, TokenPair, UUID } from "./types";

export type SignupPayload = {
  email: string;
  password: string;
  full_name: string;
  tenant_name: string;
  tenant_slug: string;
  tenant_country?: "FR" | "AE";
  tenant_vat_mode?: "standard_fr" | "uae_zero" | "exempt";
  tenant_currency?: string;
};

export type LoginPayload = {
  email: string;
  password: string;
};

export const authApi = {
  signup: (payload: SignupPayload) =>
    api.post<AuthResponse>("/api/auth/signup", payload),

  login: (payload: LoginPayload) =>
    api.post<AuthResponse>("/api/auth/login", payload),

  me: () => api.get<MeResponse>("/api/auth/me"),

  selectTenant: (tenantId: UUID) =>
    api.post<TokenPair>("/api/auth/select-tenant", { tenant_id: tenantId }),

  logout: () => api.post<void>("/api/auth/logout"),
};
